import { render, staticRenderFns } from "./SampleInfoDialog.vue?vue&type=template&id=82aaf0dc&scoped=true"
import script from "./SampleInfoDialog.vue?vue&type=script&lang=js"
export * from "./SampleInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82aaf0dc",
  null
  
)

export default component.exports